var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CopyToClipBoardv2 from 'app/components/CopyToClipboard/index';
import * as Sentry from '@sentry/browser';
import getCodeInstructions from './codeInstructions';
var refineCode = function (codes, data) {
    var responseCode = __assign({}, codes);
    Object.keys(codes).forEach(function (language) {
        if (codes[language]) {
            responseCode[language] = codes[language]
                .replace('<USERNAME>', 'neo4j')
                .replace('<PASSWORD>', data.password)
                .replace('<HOST>', data.ip)
                .replace('<BOLTPORT>', data.boltPort)
                .replace('<HTTPPORT>', data.httpPort);
        }
    });
    return responseCode;
};
var Code = function (_a) {
    var codes = _a.codes, data = _a.data;
    // If codes or data is null
    if (!codes || !data) {
        Sentry.captureMessage('Codes or data not found in Code.js');
        return (React.createElement("div", { className: "mt2 mb4" }, "Something went wrong. Try reloading the page."));
    }
    var refinedCode = refineCode(codes, data);
    var codeInstructions = getCodeInstructions(refinedCode, data);
    var handleCodeTabSelect = function (index) {
        var languages = Object.keys(codeInstructions);
        window.neo4jSandbox.tracking.event('SANDBOX_CODE_TAB_CLICK', {
            usecase: data.usecase,
            title: languages[index],
        });
    };
    var js = refinedCode.js, py = refinedCode.py, java = refinedCode.java, graphql = refinedCode.graphql, graphqlschema = refinedCode.graphqlschema, go = refinedCode.go, csharp = refinedCode.csharp;
    return (React.createElement("div", { className: "mt2 mb4" },
        React.createElement("div", null, !(js || py || java || graphql || go || csharp) && React.createElement("p", null, "Will be available soon.")),
        React.createElement("div", { className: "mt3" },
            React.createElement(Tabs, { className: "neo-tabs", style: { fontSize: 14 }, onSelect: handleCodeTabSelect },
                React.createElement(TabList, null,
                    React.createElement(Tab, null,
                        React.createElement("span", { className: "custom-radio" },
                            React.createElement("span", { className: "inner" })),
                        "Javascript"),
                    React.createElement(Tab, null,
                        React.createElement("span", { className: "custom-radio" },
                            React.createElement("span", { className: "inner" })),
                        "Python"),
                    React.createElement(Tab, null,
                        React.createElement("span", { className: "custom-radio" },
                            React.createElement("span", { className: "inner" })),
                        "Java"),
                    React.createElement(Tab, null,
                        React.createElement("span", { className: "custom-radio" },
                            React.createElement("span", { className: "inner" })),
                        "Go"),
                    React.createElement(Tab, null,
                        React.createElement("span", { className: "custom-radio" },
                            React.createElement("span", { className: "inner" })),
                        "C#"),
                    React.createElement(Tab, null,
                        React.createElement("span", { className: "custom-radio" },
                            React.createElement("span", { className: "inner" })),
                        "GraphQL")),
                Object.keys(codeInstructions).map(function (lang) { return (React.createElement(TabPanel, { key: lang }, codeInstructions[lang].steps.map(function (step, index) { return (React.createElement("div", { className: index === 0 ? 'mt4' : 'mt2', key: step.text },
                    step.text,
                    React.createElement("div", null, step.codeEle ? (React.createElement(CopyToClipBoardv2, { copyText: step.code },
                        React.createElement("code", null, step.code))) : (step.code)))); }))); })))));
};
export default Code;
